export default function initNavigation() {
    const header = document.getElementById('site-header');
    if (!header) return;

    const navItems = Array.from(header.querySelectorAll('.site-nav__item'));
    let isScrolled = false;

    /* Set initial state without animation */
    if (window.scrollY > 100) {
        isScrolled = true;
        header.classList.add('site-header--scrolled');
    }

    /* FLIP: animate nav items from their spread positions to grouped */
    function flipNav(toScrolled) {
        /* 1. FIRST — record current positions */
        const firsts = navItems.map(el => el.getBoundingClientRect());

        /* 2. LAST — snap layout to new state */
        header.classList.toggle('site-header--scrolled', toScrolled);

        const lasts = navItems.map(el => el.getBoundingClientRect());

        /* 3. INVERT — push items back to where they were visually */
        navItems.forEach((el, i) => {
            const dx = firsts[i].left - lasts[i].left;
            el.style.transition = 'none';
            el.style.transform = `translateX(${dx}px)`;
        });

        void header.offsetHeight;

        /* 4. PLAY — animate to final positions */
        requestAnimationFrame(() => {
            navItems.forEach(el => {
                el.style.transition = 'transform 0.48s cubic-bezier(0.33, 1, 0.68, 1)';
                el.style.transform = '';
            });
        });
    }

    window.addEventListener('scroll', () => {
        const shouldBeScrolled = window.scrollY > 100;
        if (shouldBeScrolled === isScrolled) return;
        isScrolled = shouldBeScrolled;
        flipNav(isScrolled);
    }, { passive: true });

    /* ── Mobile hamburger ── */
    const hamburger = header.querySelector('.nav__hamburger');
    const mobileMenu = document.querySelector('.nav__mobile-menu');
    const mobileClose = mobileMenu?.querySelector('.nav__mobile-close');
    const mobileLinks = document.querySelectorAll('.nav__mobile-menu a');

    function closeMenu() {
        hamburger?.setAttribute('aria-expanded', 'false');
        mobileMenu?.classList.remove('is-open');
    }

    hamburger?.addEventListener('click', (e) => {
        e.stopPropagation();
        const isOpen = hamburger.getAttribute('aria-expanded') === 'true';
        hamburger.setAttribute('aria-expanded', String(!isOpen));
        mobileMenu?.classList.toggle('is-open', !isOpen);
    });

    mobileClose?.addEventListener('click', closeMenu);

    mobileLinks.forEach(link => {
        link.addEventListener('click', closeMenu);
    });

    document.addEventListener('click', (e) => {
        if (!header.contains(e.target) && !mobileMenu?.contains(e.target)) {
            closeMenu();
        }
    });
}
